import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import CarouselCell from "../../SectionListCrud/editCells/CarouselCell";
const CarouselReadCell = props => {
  return /*#__PURE__*/React.createElement(CarouselCell, _extends({}, props, {
    isReadOnly: true
  }));
};
export default /*#__PURE__*/memo(CarouselReadCell);